import {
  Button,
  CloseButton,
  Dialog,
  Flex,
  Portal,
  Text,
} from "@chakra-ui/react";
import { useCallback } from "react";

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmLabel?: string;
  loading?: boolean;
}

const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel = "Confirm",
  loading,
}: ConfirmDialogProps) => {
  const onOpenChange = useCallback(
    (details: { open: boolean }) => {
      if (details.open === false) {
        onClose();
      }
    },
    [onClose],
  );

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange} lazyMount size="sm">
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content bgColor="surface.background" p={6}>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
            <Text fontSize="sm" fontWeight={600} color="text.primary" mb={2}>
              {title}
            </Text>
            <Text fontSize="sm" color="fg.muted" mb={5}>
              {description}
            </Text>
            <Flex gap={3} justify="flex-end">
              <Button
                variant="secondaryOutline"
                size="2xs"
                onClick={onClose}
                disabled={loading === true}
              >
                Cancel
              </Button>
              <Button
                colorPalette="red"
                size="2xs"
                onClick={onConfirm}
                loading={loading}
              >
                {confirmLabel}
              </Button>
            </Flex>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default ConfirmDialog;
